import { createStore, combineReducers, applyMiddleware } from 'redux';
import { allReducers, model, thunkMiddleware } from './model';
import menu from './menu';
model(menu);
export default applyMiddleware(thunkMiddleware)(createStore)(
  combineReducers({
    ...allReducers
  })
);
